import React from "react";

import { TransitionDetailsDTO } from "@fartherfinance/frontend/api/TransitionWorkflows/Types";

import Text from "@src/sharedComponents/Typography/Text";

import ExpandableTableRow from "./ExpandableTableRow";

interface TransitionExpandableContentProps {
  transitionDetails: TransitionDetailsDTO;
}

const TransitionExpandableContent: React.FC<
  TransitionExpandableContentProps
> = ({ transitionDetails }) => {
  return (
    <>
      <ExpandableTableRow
        label="Highlights and Lowlights"
        expandableContent={
          transitionDetails.highlightsAndLowlights || (
            <Text variant="body" color="textDisabled">
              None
            </Text>
          )
        }
      />
      <ExpandableTableRow
        label="Recent Updates"
        expandableContent={
          transitionDetails.recentUpdates || (
            <Text variant="body" color="textDisabled">
              None
            </Text>
          )
        }
      />
      <ExpandableTableRow
        label="Operational Notes"
        expandableContent={
          transitionDetails.operationalNotes || (
            <Text variant="body" color="textDisabled">
              None
            </Text>
          )
        }
      />
    </>
  );
};

export default TransitionExpandableContent;
